import React from 'react'
import './Faq.css'

const Faq = () => {
  return (
    <div className='dropdownmain'>


    <p className='faqsdiv'>FAQ'S</p>
<div class="dropdown">
  <p class="dropbtn">Question 1</p>
  <div class="dropdown-content">
    <a href="/">Link 1</a>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex cum eveniet ratione debitis quasi inventore culpa, necessitatibus tempora reprehenderit ea!</p>

  </div>
</div>

<div class="dropdown">
  <p class="dropbtn">Question 2</p>
  <div class="dropdown-content">
    <a href="/">Link 1</a>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex cum eveniet ratione debitis quasi inventore culpa, necessitatibus tempora reprehenderit ea!</p>

  </div>
</div>

<div class="dropdown">
  <p class="dropbtn">Question 2</p>
  <div class="dropdown-content">
    <a href="/">Link 1</a>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex cum eveniet ratione debitis quasi inventore culpa, necessitatibus tempora reprehenderit ea!</p>

  </div>
</div>
    </div>
  )
}

export default Faq